import { styled } from "@mui/material";
import { Link } from "react-router-dom";

export const StyledEmail = {
  DetailsTableEmailsContainer: styled("div")(({ theme }) => ({
    backgroundColor: "#fafafa",
  })),
  datePicker: {
    marginTop: 5,
    marginLeft: 2,
  },
};

export const StyledDetailsTable = {
  Container: styled("div")({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    padding: "16px",
    marginLeft: "32px",
    marginRight: "16px",
  }),

  LoadingContainer: styled("div")({
    flex: 1,
    display: "flex",
    height: "210px",
    justifyContent: "center",
    alignItems: "center",
  }),

  TextTitle: styled("div")({
    fontWeight: "bold",
  }),

  TextValue: styled("div")({
    marginLeft: "18px",
    fontWeight: 300,
  }),

  Image: styled("img")({
    padding: "20px",
    maxWidth: "100%",
  }),

  PdfButton: styled(Link)({
    width: "1%",
  }),
};
